'use strict';

export const getRandomNumber = (length) => {
  const secret_offset = Math.pow(10, length - 1);
  return Math.floor(secret_offset + Math.random() * (secret_offset * 9));
};
